export const URL_GET_PROJECT_ALL_DATA = '/nodes/all-data/:project_id';
export const URL_GET_PUBLIC_PROJECT_ALL_DATA = '/public/:project_id/all-nodes';
export const URL_DELETE_PROJECT_ALL_DATA_CHECKED = '/nodes/delete-data/:project_id';
export const URL_DELETE_PROJECT_ALL_CONNECTION = '/edges/delete-data/:project_id';
export const URL_GET_PROJECT_ALL_DOCUMENTS = '/documents/all-data/:project_id';
export const URL_GET_EXTERNAL_RESOURCES = '/external-resources/pab-med/:project_id';
